export const ENVIRONMENT = {
  PRODUCTION: 'PRODUCTION',
  PRE_PRODUCTION: 'PRE_PRODUCTION',
  UAT: 'UAT',
  STAGING: 'STAGING',
  DEVELOP: 'DEVELOP',
  DEV: 'DEV',
}

export const environment =
  process.env.REACT_APP_ENV === 'production'
    ? ENVIRONMENT.PRODUCTION
    : process.env.REACT_APP_ENV === 'pre-production'
    ? ENVIRONMENT.PRE_PRODUCTION
    : process.env.REACT_APP_ENV === 'uat'
    ? ENVIRONMENT.UAT
    : process.env.REACT_APP_ENV === 'stg'
    ? ENVIRONMENT.STAGING
    : process.env.REACT_APP_ENV === 'develop'
    ? ENVIRONMENT.DEVELOP
    : process.env.REACT_APP_ENV === 'dev'
    ? ENVIRONMENT.DEV
    : ENVIRONMENT.DEVELOP

const BASE = {
  DEV: {
    //BASE_API: 'http://localhost:9090',
    BASE_API: 'https://api-dev.apps.astrosystem.co',
    WSS_URL: 'wss://api-dev.apps.astrosystem.co',
    BASE_PATH_API: '/v1',
  },
  DEVELOP: {
    //BASE_API: 'http://localhost:9090',
    BASE_API: 'https://api.apps.astrosystem.co',
    WSS_URL: 'wss://api.apps.astrosystem.co',
    BASE_PATH_API: '/v1',
  },
  STAGING: {
    BASE_API: 'https://api.stg.astrosystem.co',
    WSS_URL: 'wss://api.stg.astrosystem.co',
    BASE_PATH_API: '/v1',
  },
  UAT: {
    BASE_API: 'https://api.uat.astrosystem.co',
    WSS_URL: 'wss://api.uat.astrosystem.co',
    BASE_PATH_API: '/v1',
  },
  PRE_PRODUCTION: {
    BASE_API: 'https://api.preprod.tspacesourcing.com',
    WSS_URL: 'wss://api.preprod.tspacesourcing.com',
    BASE_PATH_API: '/v1',
  },
  PRODUCTION: {
    BASE_API: 'https://api.tspacesourcing.com',
    WSS_URL: 'wss://api.tspacesourcing.com',
    BASE_PATH_API: '/v1',
  },
}

export const BASE_API = BASE[environment].BASE_API
export const BASE_PATH_API = BASE[environment].BASE_PATH_API
export const WSS_URL = BASE[environment].WSS_URL

export const PREFIX_PATH = {
  GENERAL: BASE_API,
  IMAGE: BASE_API,
}
